import Vue from 'vue';
import './registerServiceWorker';
import BootstrapVue from 'bootstrap-vue';
import moment from 'moment';
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import App from './App.vue';
import router from './router';
import store from './store';
import { initialize } from './helper/init.js';
import Helper from './helper';
import './assets/sass/app.scss';
import i18n from './i18n'

require('./bootstrap');
const numeral = require('numeral');
const VueInputMask = require('vue-inputmask').default;

library.add(fas, fab, far)

Vue.use(BootstrapVue);
Vue.use(VueInputMask);
Vue.use(Helper)

Vue.filter('formatNumber', value => numeral(value).format('0,0.[00]').replace(/,/g, ' '));
Vue.filter('currencyNum', value => numeral(value).format('(0a)'));

Vue.filter('dateFormat', function (value, format) {
  if (value) {
    return moment(String(value)).format(format || "DD.MM.YYYY")
  }
});
Vue.filter('timeFormat', function (value, format) {
  if (value) {
    return moment(String(value)).format(format || "H:mm")
  }
});
Vue.filter('datetimeFormat', function (value, format) {
  if (value) {
    return moment(String(value)).format(format || "DD.MM.YYYY H:mm")
  }
});

initialize(store, router);

//Helpers
Vue.component('pagination', require('./components/partials/paginate.vue').default);
Vue.component('datatable', require('./components/partials/Datatable.vue').default);
Vue.component('date-picker-drop', require('./components/partials/datePickerDrop.vue').default);
Vue.component('loader-wave', require('./components/partials/loader/sk-wave.vue').default);
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app');
